<template lang="pug">
.member-content
  .member-title {{ $t("ui.withdraw") }}
  template(v-if="memberBank && memberBank.length > 0")
    .bank-detail(v-if="memberBank && memberBank.length > 0")
      .bank-detail-header {{ $t("ui.bank_details") }}
      .bank-detail-body
        .row
          .col-5.col-lg-3.text-capitalize {{ $t("ui.account_name") }}
          .col-1.col-lg-auto : 
          .col-6.col-lg-8 {{ memberBank[0].bank_acc_holder }}
        .row
          .col-5.col-lg-3.text-capitalize {{ $t("ui.account_number") }}
          .col-1.col-lg-auto : 
          .col-6.col-lg-8 {{ memberBank[0].bank_acc_no }}
        .row
          .col-5.col-lg-3.text-capitalize {{ $t("ui.bank_name") }}
          .col-1.col-lg-auto : 
          .col-6.col-lg-8 {{ memberBank[0].bank_name }}
    withdrawTicketWI(:minWithdraw="minWithdraw()" :maxWithdraw="maxWithdraw()" :maxWithdrawCount="maxWithdrawCount()")
    //- .member-form
    //-   form(ref="form1" @submit.prevent="addWithdrawTicket")
    //-     .form-field
    //-       .form-label {{ $t("ui.amount") }}
    //-       .input-group
    //-         input.form-control.amount(
    //-           type='text'
    //-           v-model.trim.lazy="$v.form1.withdrawAmount.$model"
    //-           :placeholder="$t('ui.tooltips.withdraw_amount', { 'min': minWithdraw(), 'max': maxWithdraw() })"
    //-           :disabled="loading"
    //-         )
    //-       .input-feedback {{ $t("ui.tooltips.max_withdraw_count", { 'count': maxWithdrawCount() }) }}
    //-       ValidateResult(:value="$v.form1.withdrawAmount" :name="$t('ui.amount')")  
    //-     .btn-form.py-2.py-xl-3
    //-       a(href='javascript:void(0);' @click="submitForm1()")
    //-         .btn-submit {{ $t("ui.submit") }}
  template(v-else)
    .member-form
      form(ref="form2" @submit.prevent="saveBank")
        .form-field
          .form-label {{ $t("ui.bank_name") }}
          .input-group
            select.form-select.form-control(v-model="form2.bankID")
              option(v-for="bank in bankLookup" :value='bank.bank_id') {{ bank.bank_name }}
        .form-field
          .form-label {{ $t("ui.account_name") }}
          .input-group
            input.form-control(
              type='text'
              v-model.trim.lazy="$v.form2.bankAccHolder.$model"
              :disabled="loading"
            )
          ValidateResult(:value="$v.form2.bankAccHolder" :name="$t('ui.account_name')")
        .form-field
          .form-label {{ $t("ui.account_number") }}
          .input-group
            input.form-control(
              type='text'
              v-model.trim.lazy="$v.form2.bankAccNo.$model"
              :disabled="loading"
            )
          ValidateResult(:value="$v.form2.bankAccNo" :name="$t('ui.account_number')")
        .btn-form.py-2.py-xl-3
          a(href='javascript:void(0);' @click="submitForm2()")
            .btn-submit {{ $t("ui.save") }}

</template>

<script>
import { required, numeric, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  components: {
    ValidateResult: () => import("@/library/ValidateResult"),
    withdrawTicketWI: () => import("@/components/transaction/_withdrawTicketWI"),
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      form1: {
        withdrawAmount: null,
      },
      form2: {
        bankID: "",
        bankAccNo: "",
        bankAccHolder: "",
        defaultBank: true,
      },
      memberBank: [],
      bankLookup: []
    }
  },
  validations: {
    form2: {
      bankID: {
        required
      },
      bankAccHolder: {
        required
      },
      bankAccNo: {
        required
      }
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    memberBankMode() {
      return this.$store.getters.memberBankMode
    }    
  },
  mounted() { 
    this.getMemberBankMode()
    this.getMemberBankList()
    this.getMemberBankLookup()
  },
  methods:{
    getMemberBankMode() {
      if (this.isLoggedIn) {
        this.loading = true;
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberBankMode", { login_id, auth_token }).then(
          res => {
            this.loading = false;
            if (res.success) {
              // console.log(res)
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    minWithdraw() {
      return this.memberBankMode ? this.memberBankMode.setting[2].setting_value : ""
    },
    maxWithdraw() {
      return this.memberBankMode ? this.memberBankMode.setting[3].setting_value : ""
    },
    maxWithdrawCount() {
      return this.memberBankMode ? this.memberBankMode.setting[4].setting_value : ""
    },
    getMemberBankLookup() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberBankLookup", { login_id, auth_token }).then(
          res => {
            this.loading = false;
            if (res.success) {
              this.bankLookup = res.data
              this.form2.bankID = this.bankLookup[0].bank_id
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback()
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback()
            }
          }
        );
      }
    },
    getMemberBankList() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberBankList", { login_id, auth_token }).then(
          res => {
            this.loading = false
            if (res.success) {
              this.memberBank = res.data
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback()
              }
            }
          },
          err => {
            this.loading = false
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback()
            }
          }
        );
      }
    },
    saveBank(){
      this.$v.form2.$touch()
      if (!this.$v.form2.$invalid) {
        if(this.sessionToken) {
          let login_id = this.accountID
          let auth_token = this.sessionToken
          let bank_id = this.form2.bankID
          let bank_acc_holder = this.form2.bankAccHolder
          let bank_acc_no = this.form2.bankAccNo
          let is_default = this.form2.defaultBank
          this.loading = true
          this.$store
            .dispatch("user/addMemberBank", { login_id, auth_token, bank_id, bank_acc_holder, bank_acc_no, is_default })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.resetForm2()
                this.getMemberBankList()
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.addbank_success"), "success")
              } else {
                this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error")
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              this.feedback.status = this.$t("error." + response.status)
              this.$helpers.showDialog(this.$t("ui.cancel").toUpperCase(), this.$t("message.list." + response.status), "error")
            });
        }
      }
    },
    submitForm2() {
      this.saveBank()
    },
    resetForm2() {
      this.feedback.success = true
      this.feedback.status = ""
      this.form2.bankID = ""
      this.form2.bankAccHolder = ""
      this.form2.bankAccNo = ""
      this.form2.defaultBank = true
      this.$v.form2.$reset()
    }
  }
}
</script>